// Shopify's customer-signup form requires an hCaptcha token that Shopify's own
// script injects by listening for the form's native 'submit' event. If we
// intercept that event with preventDefault() and send the request ourselves via
// fetch, we race Shopify's captcha script and the submission gets rejected
// ("Missing CAPTCHA token"). So we let the form submit natively — this causes a
// full page reload, which we smooth over below by reopening the same modal with
// a success message once the page comes back.

const STORAGE_KEY = 'notifyMeReopenModalId';

// Right before a notify-me form actually submits, remember which modal it
// belongs to so we can reopen it after the page reloads.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!form.classList || !form.classList.contains('notify-me__form')) return;

    const modal = form.closest('.notify-me-modal');
    if (!modal || !modal.id) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, modal.id);
    } catch (e) {
      // sessionStorage unavailable (private browsing etc.) — the modal just
      // won't auto-reopen, submission still goes through fine.
    }
  },
  true
);

// After a reload following a successful customer-form submission, Shopify adds
// customer_posted=true to the URL. If we were expecting that (i.e. we stashed a
// modal id before submitting), reopen the modal and show the success message.
document.addEventListener('DOMContentLoaded', () => {
  let modalId;
  try {
    modalId = sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return;
  }
  if (!modalId) return;

  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }

  const params = new URLSearchParams(window.location.search);
  const posted = params.get('customer_posted') === 'true';

  // Clean the query param either way so a manual refresh doesn't repeat this.
  if (params.has('customer_posted')) {
    params.delete('customer_posted');
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  const modal = document.getElementById(modalId);
  if (!modal) return;

  const opener = document.querySelector(`modal-opener[data-modal="#${modalId}"] button`);

  // Wait a tick for modal-dialog's own connectedCallback (which moves it to
  // document.body) to have run.
  requestAnimationFrame(() => {
    modal.show(opener);

    const form = modal.querySelector('.notify-me__form');
    const successMessage = modal.querySelector('.notify-me__message--success');
    const errorMessage = modal.querySelector('.notify-me__message--error');

    if (posted) {
      if (form) form.classList.add('hidden');
      if (successMessage) successMessage.classList.remove('hidden');
    } else if (errorMessage) {
      errorMessage.classList.remove('hidden');
    }
  });
});

// Reset a notify-me modal back to its default state each time it's closed, so
// a previous success/error message doesn't linger the next time it's opened.
document.body.addEventListener('modalClosed', () => {
  document.querySelectorAll('.notify-me-modal').forEach((modal) => {
    const form = modal.querySelector('.notify-me__form');
    const successMessage = modal.querySelector('.notify-me__message--success');
    const errorMessage = modal.querySelector('.notify-me__message--error');
    if (!form) return;

    form.classList.remove('hidden');
    form.reset();
    if (successMessage) successMessage.classList.add('hidden');
    if (errorMessage) errorMessage.classList.add('hidden');
  });
});
